import styled from "styled-components"
import { media } from "../mediaStyles"
import { colors } from "../Color"
import margins from "../MarginContainer"
import getFontsByProps from "../getFontsByProps"

const size = {
  small: "12px",
  medium: "16px",
  large: "20px",
}

const sizeMobile = {
  small: "16px",
  medium: "18px",
  large: "20px",
}

const Text = styled.div`
  position: relative;
  display: block;
  overflow-wrap: initial;
  color: ${props => (props.color ? colors[props.color] : colors.primary)};
  font-size: ${props =>
    props.size ? sizeMobile[props.size] : sizeMobile.large};
  font-family: ${getFontsByProps};
  font-weight: ${props => (props.highlight ? 600 : 400)};
  line-height: 1.5em;

  ${media.small`
    font-size: ${props => (props.size ? size[props.size] : size.large)};
    font-weight: ${props => (props.highlight ? 600 : 400)};
  `};

  ${margins};
`

export default Text
